var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_706_140916",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.300293,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_706_140916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80029 2.5C7.88276 2.5 7.9674 2.51814 8.05423 2.55443C8.14106 2.59032 8.21738 2.64051 8.28319 2.70497L11.0961 5.44308C11.2281 5.57162 11.2961 5.72853 11.3001 5.91381C11.3045 6.09871 11.2365 6.25138 11.0961 6.37181C10.972 6.49263 10.817 6.55304 10.6311 6.55304C10.4455 6.55304 10.2907 6.49263 10.1666 6.37181L8.48182 4.74365L8.48182 11.8365C8.48182 12.0132 8.41363 12.168 8.27724 12.3008C8.14086 12.4336 7.98188 12.5 7.80029 12.5C7.61871 12.5 7.45973 12.4336 7.32335 12.3008C7.18696 12.168 7.11877 12.0132 7.11877 11.8365L7.11877 4.74365L5.44648 6.37181C5.31406 6.50073 5.15507 6.56307 4.96953 6.55883C4.78358 6.55497 4.62857 6.49263 4.50447 6.37181C4.36412 6.24327 4.29613 6.08848 4.30049 5.90745C4.30446 5.72641 4.37245 5.57162 4.50447 5.44308L7.3174 2.70497C7.38321 2.64051 7.45953 2.59032 7.54636 2.55443C7.63318 2.51814 7.71783 2.5 7.80029 2.5Z",
    fill: "#13ACAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.ab0c851aee261caaf81581706cf17ab4.svg";
export { ForwardRef as ReactComponent };